function WYSIWYGEditor() {}

WYSIWYGEditor.THEME_DEFAULT = {
  // Theme options
  "theme": "modern",
  // http://www.tinymce.com/wiki.php/Plugins
  "plugins": [
      "advlist autolink lists link image preview hr anchor pagebreak",
      "searchreplace wordcount visualblocks visualchars code fullscreen",
      "insertdatetime media nonbreaking table contextmenu directionality",
      "paste textcolor colorpicker textpattern"
  ],
  "toolbar": "insertfile undo redo | bold italic underline | styleselect formatselect fontselect fontsizeselect | forecolor backcolor" +
             " | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image media | ltr rtl | visualchars visualblocks  | preview code fullscreen",
  "toolbar_items_size": "small"
};

WYSIWYGEditor.THEME_SIMPLE = {
  // Theme options
  "selector": "textarea",
  // http://www.tinymce.com/wiki.php/Plugins
  "plugins": [
    "autolink code fullscreen textcolor colorpicker paste link image"
  ],
  "toolbar1": "bold italic underline | alignleft aligncenter alignright alignjustify | link image code fullscreen",
  "toolbar2": "forecolor backcolor | fontselect fontsizeselect",
  "toolbar_items_size": 'small',
  "menubar": false,
  "statusbar": false
};

WYSIWYGEditor.addEditor = function (selector, theme) {
  if (theme == null) theme = WYSIWYGEditor.THEME_DEFAULT;

  $(selector).tinymce($.extend(theme, {
    "script_url" : "/libs/vendor/tinymce-4.1.10/tinymce.jquery.min.js",
    "language" : $.inArray(Config.languageISOCode, ['he']) != -1 ? "en" : Config.languageISOCode,
    "document_base_url" : Config.serverURL,
    "convert_urls" : false
  }));

};

WYSIWYGEditor.removeEditor = function (selector) {
  $(selector).each(function(index, el) {
    $(el).tinymce().remove();
  });
  //Этот вариант убивает только первый элемент в коллекции, видимо коллекции не поддерживаются в tinymce jquery plugin-е
//  $(selector).tinymce().remove();
};


_onload_functions[_onload_functions.length] = function() {
  WYSIWYGEditor.addEditor("textarea.tinymce", WYSIWYGEditor.THEME_DEFAULT);
  WYSIWYGEditor.addEditor("textarea.tinymce-simple", WYSIWYGEditor.THEME_SIMPLE);
};